export default __webpack_public_path__ + "static/media/past-app.5655ecdf.svg";